import type { IconProps } from './IconProps';

export const ClockIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_10180_26045)">
      <path
        d="M13.9164 8.00049C13.9164 4.73291 11.2679 2.08367 8.00037 2.0835C4.73268 2.0835 2.08337 4.7328 2.08337 8.00049C2.08355 11.268 4.73279 13.9165 8.00037 13.9165C11.2678 13.9163 13.9162 11.2679 13.9164 8.00049ZM7.25037 4.00049C7.25037 3.58627 7.58615 3.25049 8.00037 3.25049C8.41443 3.25066 8.75037 3.58638 8.75037 4.00049V7.53662L11.0023 8.6626C11.3726 8.84784 11.5223 9.29807 11.3373 9.66846C11.1521 10.0389 10.7019 10.1895 10.3314 10.0044L7.66443 8.67139C7.41044 8.54439 7.25049 8.28444 7.25037 8.00049V4.00049ZM15.4164 8.00049C15.4162 12.0963 12.0962 15.4163 8.00037 15.4165C3.90436 15.4165 0.58355 12.0965 0.583374 8.00049C0.583374 3.90438 3.90425 0.583496 8.00037 0.583496C12.0963 0.583672 15.4164 3.90449 15.4164 8.00049Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10180_26045">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
